import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { UserDto } from '../../dto/user/UserDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiAddUser = async (dto: UserDto) => {
  const params: IApiParams = {
    url: '/license/addUserId.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
